function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* script */
//
//
//
//
//
//
//
import { isFlexSupported } from './utils';
var __vue_script__ = {
  name: 'Steps',
  provide: function provide() {
    return {
      stepRoot: this
    };
  },
  props: {
    prefixCls: {
      type: String,
      default: 'v-steps'
    },
    iconPrefix: {
      type: String,
      default: 'vicon'
    },
    direction: {
      type: String,
      default: 'horizontal'
    },
    labelPlacement: {
      type: String,
      default: 'horizontal'
    },
    current: {
      type: [Number, String],
      default: 0
    },
    status: {
      type: String,
      default: 'process'
    },
    size: String,
    progressDot: Boolean
  },
  data: function data() {
    return {
      descendants: [],
      isSupportFlex: isFlexSupported(),
      lastDescendantOffsetW: 0
    };
  },
  computed: {
    classes: function classes() {
      var _ref;

      var prefixCls = this.prefixCls,
          direction = this.direction,
          size = this.size,
          progressDot = this.progressDot,
          labelPlacement = this.labelPlacement;
      var adjustLabelPlacement = progressDot ? 'vertical' : labelPlacement;
      return _ref = {}, _defineProperty(_ref, prefixCls, true), _defineProperty(_ref, "".concat(prefixCls, "-").concat(direction), true), _defineProperty(_ref, "".concat(prefixCls, "-").concat(size), size), _defineProperty(_ref, "".concat(prefixCls, "-label-").concat(adjustLabelPlacement), direction === 'horizontal'), _defineProperty(_ref, "".concat(prefixCls, "-dot"), !!progressDot), _ref;
    },
    normalizeCurrent: function normalizeCurrent() {
      var current = this.current;
      return Number.isNaN(Number(current)) ? 0 : Number(current);
    }
  },
  methods: {
    addDescendant: function addDescendant(item) {
      this.descendants.push(item);
    },
    removeDescendant: function removeDescendant(item) {
      this.descendants = this.descendants.filter(function (v) {
        return v !== item;
      });
    },
    updateLastDescendantOffsetW: function updateLastDescendantOffsetW(width) {
      this.lastDescendantOffsetW = width;
    }
  },
  watch: {
    descendants: function () {
      var descendants = this.descendants;
      var len = descendants.length;
      this.descendants.forEach(function (v, i) {
        var nv = v;
        nv.seq = i;
        nv.stepSize = len;
        nv.isLast = i === len - 1;
      });
    }
  }
};
/* template */

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: _vm.classes
  }, [_vm._t("default")], 2);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* component normalizer */

function __vue_normalize__(template, style, script, scope, functional) {
  var component = (typeof script === 'function' ? script.options : script) || {}; // For security concerns, we use only base name in production mode.

  component.__file = "steps.js";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;
  return component;
}
/* style inject */

/* style inject SSR */


export default __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, undefined, undefined);